import api from './api'
import log from './logger'
import storage from './storage'
import toast from './toast'

import { IService } from '../interfaces/service.interface'

const services: IService = {
  api,
  log,
  storage,
  toast,
}

export default services
